@for (message of messages; track message) {
  <div class="alert alert-{{message.type}}"
    [ngClass]="{'margin-bottom-20': $last}"
    [@flashState]>
    <span class="message" [innerHTML]="message.message"></span>
    <button type="button"
      class="close"
      (click)="close(message)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}
